import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  makeStyles
} from "@material-ui/core";
import * as React from "react";
import { CheckedIcon, DraftIcon } from "../../icons";
import FolderIcon from "../../icons/components/folder-icon";
import { Color } from "../../theme";

type Props = {
  label?: string;
  groupingKey: string;
  references: any[];
  value: string[];
  onChange: (ids: string[]) => void;
};

export const ReferenceList = React.forwardRef<HTMLDivElement, Props>(
  ({ label, groupingKey, references, value, onChange }, ref) => {
    const classes = useStyles();

    return (
      <div className={classes.root} ref={ref}>
        {label && <Typography variant="h6">{label}</Typography>}
        <FormGroup key={groupingKey}>
          <FormControlLabel
            control={
              <Checkbox
                name={groupingKey}
                checked={references.some((r) => value.includes(r._id))}
                onChange={(e) => {
                  if (e.target.checked) {
                    onChange([...value, ...references.map((r) => r._id)]);
                  } else {
                    onChange(value.filter((id) => !references.some((r) => r._id === id)));
                  }
                }}
              />
            }
            label={
              <Box className={classes.iconWithText}>
                <FolderIcon />
                <Typography variant="h6" style={{ paddingTop: "2px" }}>
                  {groupingKey}
                </Typography>
              </Box>
            }
          />
          <Box className={classes.referenceEntry}>
            {references.map((reference) => {
              return (
                <Box key={reference._id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checkedIcon={<CheckedIcon htmlColor={Color.PrimaryLight} />}
                        name={reference.Name ?? undefined}
                        checked={value.includes(reference._id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChange([...value, reference._id]);
                          } else {
                            onChange(value.filter((id) => id !== reference._id));
                          }
                        }}
                      />
                    }
                    label={
                      <Box className={classes.iconWithText}>
                        <DraftIcon htmlColor={Color.DetailsInput} />
                        <Typography variant="body1" style={{ paddingTop: "2px" }}>
                          {[
                            reference.Name,
                            reference.Position,
                            reference.Relation,
                            reference.TakenOn
                              ? new Date(reference.TakenOn).toISOString().split("T")[0]
                              : ""
                          ].join(" ")}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              );
            })}
          </Box>
        </FormGroup>
      </div>
    );
  }
);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    paddingLeft: "0.5rem"
  },
  referenceEntry: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    paddingLeft: "1rem"
  },
  iconWithText: {
    display: "flex",
    flexDirection: "row",
    gap: "0.25rem",
    alignItems: "center",
    paddingLeft: "0.25rem"
  }
}));

ReferenceList.displayName = "ReferenceList";

export default ReferenceList;
